import React, { useEffect, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import { CrossIcon, fileIcons, Myfiles, StorageIcon } from "../FileRepo/Icons";
import SearchBar from "../Search/SearchBar";
import BreadCrumb from "../FileRepo/Components/BreadCrumb";
import { useAuth } from "../../features/auth/AuthContext";
import SecondaryBtn from "../Buttons/SecondaryBtn";
import PrimaryBtn from "../Buttons/PrimaryBtn";
import { toast } from "react-toastify";
import Loader from "../FileRepo/Components/Loader";
import { useRepoQuery } from "../FileRepo/hooks/useRepoQuery";
import Pagination from "../FileRepo/Components/Pagination";
import useBranding from "../../hooks/useBranding";

const UploadFromRepoModal = ({
  open,
  setOpen,
  setOpenFileUpload,
  setSelectedRepoFiles,
  selectedRepoFiles,
  selectedNormalFiles,
  maxFiles = 2,
  allowedTypes = null,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [path, setPath] = useState([
    { id: 0, name: "Repository", item_type: "folder" },
  ]);
  const [search, setSearch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [currentFolder, setCurrentFolder] = useState({
    id: 0,
    name: "Repository",
    item_type: "folder",
  });

  const { token } = useAuth();
  const branding = useBranding();

  const {
    data: repoData,
    isLoading,
    isFetching,
  } = useRepoQuery({
    token,
    endpoint: "manual-upload/folder-contents/",
    queryKey: "uploadFromRepo",
    folderId: currentFolder?.id === 0 ? null : currentFolder?.id,
    search,
    page: currentPage,
    enabled: open,
  });

  const data = repoData?.all || [];

  function handleBreadCrumClick(folder, index) {
    const newPath = path.slice(0, index + 1);
    setPath(newPath);
    setCurrentFolder(folder);
    setCurrentPage(1);
  }

  const handleItemClick = (item) => {
    if (item.item_type === "folder") {
      const folder = { id: item.id, name: item.folder_name };
      setCurrentFolder(folder);
      setCurrentPage(1);
      setPath((prev) => [...prev, folder]);
      return;
    }
    setSelectedFiles((prev) =>
      prev.some((file) => file.id === item.id)
        ? prev.filter((file) => file.id !== item.id)
        : [...prev, item],
    );
  };

  const close = () => {
    setSelectedFiles([]);
    setCurrentFolder({ id: 0, name: "Repository", item_type: "folder" });
    setPath([{ id: 0, name: "Repository", item_type: "folder" }]);
    // setData([]);
    setOpen(false);
  };

  const handleSubmit = () => {
    const allowedExtensions = allowedTypes || [
      "pdf",
      "docx",
      "doc",
      "xls",
      "xlsx",
      "csv",
      "png",
      "jpg",
      "jpeg",
      "txt",
    ];

    if (selectedFiles?.length === 0) return;
    if (selectedFiles.length > maxFiles) {
      toast.error(`Maximum ${maxFiles} files can be uploaded`);
    } else if (selectedFiles?.length + selectedNormalFiles?.length > maxFiles) {
      toast.error(`You can only upload ${maxFiles} files`);
      return;
    } else {
      const invalidFile = selectedFiles.find(
        ({ file_type }) => !allowedExtensions.includes(file_type),
      );
      if (invalidFile) {
        return toast.error(
          `File type not supported: ${invalidFile?.file_type}`,
        );
      }
      setSelectedRepoFiles(selectedFiles);
      setSelectedFiles([]);
      setCurrentFolder({ id: 0, name: "Repository", item_type: "folder" });
      setPath([{ id: 0, name: "Repository", item_type: "folder" }]);
      // setData([]);
      setOpen(false);
    }
  };

  function onPageChange(page) {
    setCurrentPage(page);
  }

  return (
    <CustomModal
      width={800}
      childMT={0}
      open={open}
      isHeader={false}
      title={branding?.filename || "My Files"}
    >
      <div className="flex flex-col justify-between">
        <div className="flex justify-between items-center">
          {repoData?.storage !== null || repoData?.storage !== undefined ? (
            <div className="flex items-center">
              <div className="flex items-center gap-1">
                <Myfiles />
                <span className="text-[#0068FF] text-[1rem] font-medium">
                  {branding?.filename || "My Files"}
                </span>
              </div>
              <div className="w-px self-stretch bg-[#D9D9D9] mx-2" />

              <div className="flex items-center gap-2">
                <StorageIcon />
                <span className="text-[#555555] font-medium text-[0.85rem]">
                  {repoData?.storage?.toFixed(2)}% Storage Used{" "}
                </span>
              </div>
            </div>
          ) : (
            // <div
            //   role="heading"
            //   aria-level="1"
            //   title={title}
            //   className="text-[#232323] font-medium text-base break-words max-w-[95%]"
            // >
            //   {title}
            // </div>
            <div className="flex items-center gap-1">
              <Myfiles />
              <span className="text-[#0068FF] text-[1rem] font-medium">
                {branding?.filename || "My Files"}
              </span>
            </div>
          )}
          <button onClick={close} className="border-none bg-transparent">
            <CrossIcon />
          </button>
        </div>
        <div className="flex flex-col gap-3 mt-4">
          <div className="flex items-center gap-3">
            <span className="min-w-fit text-[#000000] text-[0.9rem] font-normal">
              Select File
            </span>
            {currentFolder?.id !== 0 && (
              <SearchBar
                search={search}
                setSearch={setSearch}
                filterSort={false}
              />
            )}
          </div>
          {currentFolder?.id !== 0 && (
            <BreadCrumb
              marginTop="mt-0"
              path={path}
              onFolderClick={handleBreadCrumClick}
            />
          )}

          <div className="h-[50vh] flex flex-col gap-1 overflow-auto mt-3">
            {isLoading || isFetching ? (
              <Loader />
            ) : (
              <>
                {data.map((item) => {
                  const { item_type, folder_name, file_name, file_type, id } =
                    item;

                  const isFolder = item_type === "folder";
                  const Icon = isFolder
                    ? fileIcons?.["folder"]
                    : fileIcons?.[file_type] || <></>;
                  const label = isFolder ? folder_name : file_name;
                  //   const id = isFolder ? item?.folder_id : item?.file_id;
                  const isSelected = selectedFiles?.find(
                    (file) => file?.id === id,
                  );

                  return (
                    <div
                      className={`w-full p-2 rounded-md ${
                        isSelected ? "bg-[#E0F4FF]" : ""
                      } `}
                    >
                      <button
                        key={id || label}
                        className={`bg-transparent ${
                          isSelected ? "bg-[#E0F4FF]" : ""
                        }  border-none flex items-center gap-2 w-full`}
                        onClick={() => {
                          handleItemClick(item);
                        }}
                      >
                        {Icon && <Icon />}
                        <span
                          className={`${
                            isSelected ? "font-medium" : ""
                          } text-[#333333] font-normal text-[0.8rem]`}
                        >
                          {label}
                        </span>
                      </button>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalCount={repoData?.count || 12}
        />
        <div className="flex justify-end w-full items-center gap-2">
          <SecondaryBtn label="Cancel" handleClick={close} />
          <PrimaryBtn
            label="Choose"
            disabled={selectedFiles.length === 0}
            handleClick={handleSubmit}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default UploadFromRepoModal;
